const languagesOrder = ['English', 'Russian'];

export default languagesOrder;
